var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "plqwlvhiza",
    d: "M12.39.29v10-10z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1215 -365) translate(1215 365)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#D6B56D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V16H0z",
    transform: "translate(6 7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 7) translate(1.11 2.29)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#840533",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.89 2.71L3.39 0 5.89 2.71M3.39.71v10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#840533",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.89 11L12.39 8.29 14.89 11",
    transform: "matrix(1 0 0 -1 0 19.29)"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#840533",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(1 0 0 -1 0 10.58)",
    xlinkHref: "#plqwlvhiza"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.c8d66686.svg";
export { ForwardRef as ReactComponent };